/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class HealthIcon extends BaseIcon {
  getChildren = () => [ <path d="M13,14H3a2,2,0,0,1-2-2V6A2,2,0,0,1,3,4H5V3A1,1,0,0,1,6,2h4a1,1,0,0,1,1,1V4h2a2,2,0,0,1,2,2v6A2,2,0,0,1,13,14ZM9,3H7A1,1,0,0,0,6,4h4A1,1,0,0,0,9,3Zm2,5H9V6H7V8H5v2H7v2H9V10h2Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
